import styled from 'styled-components';

export const DetailProfileCompanyWrapper = styled.div`
  width: 81.25rem;
  margin-left: 12.5rem;
`;
